import type { InvitationPayload, Persona } from '@/invitation/payload/types';

/**
 * 008 · US10 — Devuelve los novios en el orden elegido por la pareja para portada/hero/monograma.
 * Default 'bride_first' (novia primero), que es el comportamiento histórico.
 */
export function orderedCouple(p: InvitationPayload): { primero: Persona; segundo: Persona } {
  return p.boda.ordenNombres === 'groom_first'
    ? { primero: p.novio, segundo: p.novia }
    : { primero: p.novia, segundo: p.novio };
}
